<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.25 0.25H1.24609C0.558594 0.25 0 0.816406 0 1.51172V16.4883C0 17.1836 0.558594 17.75 1.24609 17.75H16.25C16.9375 17.75 17.5 17.1836 17.5 16.4883V1.51172C17.5 0.816406 16.9375 0.25 16.25 0.25ZM5.28906 15.25H2.69531V6.89844H5.29297V15.25H5.28906ZM3.99219 5.75781C3.16016 5.75781 2.48828 5.08203 2.48828 4.25391C2.48828 3.42578 3.16016 2.75 3.99219 2.75C4.82031 2.75 5.49609 3.42578 5.49609 4.25391C5.49609 5.08594 4.82422 5.75781 3.99219 5.75781ZM15.0117 15.25H12.418V11.1875C12.418 10.2188 12.3984 8.97266 11.0703 8.97266C9.71875 8.97266 9.51172 10.0273 9.51172 11.1172V15.25H6.91797V6.89844H9.40625V8.03906H9.44141C9.78906 7.38281 10.6367 6.69141 11.8984 6.69141C14.5234 6.69141 15.0117 8.42188 15.0117 10.6719V15.25Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
